module.exports = __webpack_public_path__ + "img/pro_s3_img2.67bad01c.jpg";